import PropTypes from 'prop-types';
import React from 'react';
import Icon, { GLYPHS } from '../../../common/icon';
import BarberLocations from '../../barbers/containers/BarberLocations';

const kindToNameMap = {
  2: 'Shop',
  5: 'Brand',
};

const DeletedStaffList = ({ staffMembers, isBrandView, onRestore }) => (
  <div className="c-table-with-sticky-header u-position-relative u-mb+">
    <div className="u-scrollable-visible">
      <div className="c-table-card c-table-new c-sticky-header u-no-shadow u-table-layout-fixed">
        <div className="c-table-card__head">
          <div className="c-table-card__cell c-label u-2/10">Username</div>
          <div className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-2/10">Kind</div>
          <div
            className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-3/10"
            display-if={isBrandView}
          >
            Locations
          </div>
          <div className="c-table-card__cell c-label u-1/10">Actions</div>
        </div>
      </div>
      <div className="c-table-card c-table-new u-table-layout-fixed c-no-hover">
        {staffMembers.map(staffMember => (
          <div key={staffMember.id} className="c-table-card__row">
            <div className="c-table-card__cell u-2/10">
              <div className="u-text-trim">
                <span className="u-mr--">{staffMember.username}</span>
              </div>
            </div>
            <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-2/10">
              <div className="u-text-trim">{kindToNameMap[staffMember.kind]}</div>
            </div>
            <BarberLocations locations={staffMember.shops} display-if={isBrandView} />
            <div className="c-table-card__cell u-1/10">
              <button
                type="button"
                className="c-btn c-btn--blank u-pl0"
                title="Restore"
                onClick={() => onRestore(staffMember.id)}
              >
                <Icon glyph={GLYPHS.refresh} size="medium" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

DeletedStaffList.propTypes = {
  staffMembers: PropTypes.array.isRequired,
  onRestore: PropTypes.func.isRequired,
  isBrandView: PropTypes.bool,
};

DeletedStaffList.defaultProps = {
  isBrandView: false,
};

export default DeletedStaffList;
